// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__JK4XY","cart-items-wrapper":"Cart_cart-items-wrapper__L4S1w"};